// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__AMMOp","notFoundImg":"NotFound_notFoundImg__zidHj","notFoundBtn":"NotFound_notFoundBtn__XnDno"};